// icon:temperature-half | Unicons https://iconscout.com/unicons | Iconscout
import * as React from "react";

function IconRoomTemperature(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      height="1em"
      width="1em"
      {...props}
    >
      <path d="M13 15.28V10.5a1 1 0 00-2 0v4.78A2 2 0 0010 17a2 2 0 004 0 2 2 0 00-1-1.72zM16.5 13V5.5a4.5 4.5 0 00-9 0V13a6 6 0 003.21 9.83A7 7 0 0012 23a6 6 0 004.5-10zm-2 7.07a4 4 0 01-5.32-6 1 1 0 00.3-.71V5.5a2.5 2.5 0 015 0v7.94a1 1 0 00.3.71 4 4 0 01-.28 6z" />
    </svg>
  );
}

export default IconRoomTemperature;
